import { useNavState } from '@/providers/NavStateProvider';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useCurrentPurchaseOrder } from '@/providers/PurchaseOrderProvider';
import { ScrollTop } from '@/components/element/ScrollTop';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { RelatedOrderCreateForm } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/related_projects/{components}/RelatedOrderCreateForm';
import { RelatedProjectsElement } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/related_projects/{components}/RelatedProjectsElement';

type FormInputs = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  sales_order_id: number;
};
export const PurchaseOrderRelatedProjects = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle(`Related Sales Projects`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `Purchase Orders - ${_t_!.name}`, path: `/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders` },
        { label: `Purchase Order Detail`, path: `/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders/${_po_!.id}` },
      ]),
    []
  );

  const navigate = useNavigate();
  const { _w_, _t_, me, meTeamMember } = useCurrentTeamMember();
  const { _po_, mePurchaseOrderMember } = useCurrentPurchaseOrder();

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <div className="container-fluid py-4">
        <div className="row">
          <div className="col-12 col-lg-9 mx-auto">
            <div className="card mb-4" id="basic-info">
              <div className="card-header d-flex align-items-center">
                <div className="col-md-8">
                  <h5 className="mb-0">関連プロジェクト（売上）</h5>
                </div>
              </div>
              <div className="card-body pt-0 row">
                <div className="form-group">
                  <label>プロジェクト名</label>
                  <p className="form-text text-muted text-sm ms-1">{_po_!.name}</p>
                </div>
                <hr className="horizontal dark my-3" />

                <RelatedOrderCreateForm />

                <hr className="horizontal dark my-3" />

                <RelatedProjectsElement />
              </div>
              <div className="card-footer d-flex align-items-center justify-content-end pt-0">
                <Link to="" className="btn btn-outline-secondary" onClick={() => navigate(-1)}>
                  プロジェクト詳細へ
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
